import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DbContextService } from '../../../services/db-context.service';
import { OfflineQueueService } from '../../../services/offline-queue.service';
import { OnlineOfflineService } from '../../../services/online-offline.service';
import { Helper } from '../../common/helper';
import { IFSSurveyData } from '../model/ifs-survey-data';
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class IfsSurveyService {

  constructor(private http: HttpClient,
    private dbxService: DbContextService,) { }

  getIFSSurveyQuestionsList() {
    return this.http.get(Helper.API_URL() + '/api/Maintenance/GetIFSSurveyQuestionsList/FALSE');
  }

  submitIFSSurvey(ifsSurvey: IFSSurveyData[]) {
    return this.http.post(Helper.API_URL() + '/api/Maintenance/SubmitIFSSurvey', ifsSurvey);
  }

  getIFSSurveyList(periodFrom: string, periodTo: string) {
    let param = {
      'periodFrom': periodFrom,
      'periodTo': periodTo,
    }
    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetIFSSurveyList', param);
  }

  //index db ----------------------------------------------------------------------------------------------------

  getIFSSurveyQuestionsIndxDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblIFSSurveyQuestions', 'readwrite');
        let store = tx.objectStore('OWS_tblIFSSurveyQuestions');
        store.getAll().then(
          (res: IFSSurveyData[]) => {
            resolve(res);
          })
      });
    });
    return promise;
  }

  saveIFSSurveyQuestionsIndxDb(ifsSurveyQuestionList: IFSSurveyData[]) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblIFSSurveyQuestions', 'readwrite');
      let store = tx.objectStore('OWS_tblIFSSurveyQuestions');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      store.clear();
      try {
        ifsSurveyQuestionList.forEach(q => {
          store.add(q);
        })
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }

    });
  }

  getIsIFSSurveyTakenIndxDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblIFSSurvey', 'readwrite');
        let store = tx.objectStore('OWS_tblIFSSurvey');
        store.get('Taken').then(
          (res: any) => {
            resolve(res);
          })
      });
    });
    return promise;
  }

  saveIsIFSSurveyTakenIndxDb(isTaken: boolean) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblIFSSurvey', 'readwrite');
      let store = tx.objectStore('OWS_tblIFSSurvey');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      store.get('Taken').then((res: any) => {
        let survey = {
          'id': 'Taken',
          'isSurveyTaken': isTaken
        }
        try {
          if (res == null) {
            store.add(survey);
          } else {
            store.put(survey);
          }
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }
      })

    });
  }

  submitIFSSurveyIndxDb(onlineOfflineService: OnlineOfflineService, offlineQueueService: OfflineQueueService
    , ifsSurveyQuestionList: IFSSurveyData[]): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let surveyId = (new Date()).toISOString();

      //add to queue
      offlineQueueService.pushQueueIndxdb('/api/Maintenance/SubmitIFSSurvey', Helper.deepCopy(ifsSurveyQuestionList),
        onlineOfflineService.isAuthenticated, Helper.Constants.RequestModules.IFS_SURVEY, surveyId, null);

      let survey = {
        'id': surveyId,
        'param': ifsSurveyQuestionList
      }

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblIFSSurvey', 'readwrite');
        let store = tx.objectStore('OWS_tblIFSSurvey');
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };
        //ifsSurveyQuestionList.forEach(q => {
        //  store.add(q);
        //})
        try {
          store.add(survey);
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }

        resolve(true);
      })
    })
    return promise;
  }

  deleteIFSSurveyIndxDb(surveyID: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblIFSSurvey', 'readwrite');
        let store = tx.objectStore('OWS_tblIFSSurvey');
        store.get(surveyID).then((r: any) => {
          store.delete(surveyID).then(() => {
            resolve(true);
          });
        })
      })
    })
    return promise;

  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
